import { createAsyncThunk } from '@reduxjs/toolkit'

import { ITypeTicketCollectionData } from 'meta/pages/v4/typeticketcollection'
import { TypeTicketCollectionController } from 'controller/typeticketcollection'

type Returned = ITypeTicketCollectionData

type Props = {
  id: number
}

export const getData = createAsyncThunk<Returned, Props>('pages/typeticketcollection/data', async (props) => {
  const { id } = props

  return TypeTicketCollectionController.getData({ id })
})
